import http from '../../http-common-admin';
import httpStudent from '../../http-common-students';

class UserService {

    getAll(universityID){
        return http.get(`/users?universityID=${universityID}`);
    }
    getAllLogin(tipoDisplay, universityID){
        return http.get(`/users?tipoDisplay=${tipoDisplay}&universityID=${universityID}`)
    }
    getAllDeliberationEnLigne(universityID, typeDisplay, enLigne){
        return http.get(`/users?universityID=${universityID}&typeDisplay=${typeDisplay}&enLigne=${enLigne}`);
    }

    async getImage(typeDisplay, imageName) {
       return  http.get(`/users?typeDisplay=${typeDisplay}&imageName=${imageName}`);
      }
    
    create(data){
        return  http.post("/users", data);
    }

    getcode(id, tipoPedido, dadoPesquisa){
        return http.get(`/users/${id}?tipoPedido=${tipoPedido}&dadoPesquisa=${dadoPesquisa}`)
    }

     userStudentGetcode(id, tipoPedido, email, password, typeUtilisateur, studentMatriculaID){
        return http.get(`/users/${id}?tipoPedido=${tipoPedido}&email=${email}&password=${password}&typeUtilisateur=${typeUtilisateur}&studentMatriculaID=${studentMatriculaID}`)
    }

    userStudentGetcodeIDSeulement(id, tipoPedido){
        return http.get(`/users/${id}?tipoPedido=${tipoPedido}`)
    }
    // Search user ID

    getID(id){
        return http.get(`/users/${id}`)
    }
    update(id, data){
        return http.put(`/users/${id}`, data)
    }

    updateStudents(id, data){
        return httpStudent.put(`/users/${id}`, data)
    }

    updateStudent(id, data){

        return httpStudent.put(`/userStudent/${id}`, data)
    }
    // delete user

    delete(id){
        return http.delete(`/users/${id}`)
    }
}

export default new UserService();